<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-close-circle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22zm0-4c-9.941 0-18-8.059-18-18S14.059 6 24 6s18 8.059 18 18-8.059 18-18 18zm4.95-25.778a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414L26.828 24l4.95 4.95a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0L24 26.828l-4.95 4.95a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l4.95-4.95-4.95-4.95a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0l4.95 4.95 4.95-4.95z"/></svg>
</template>
<script>

export default {
  name: 'IconCloseCircle',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
